var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.60601C18 10.1815 17.537 10.6445 16.9615 10.6445H10.0385V17.5676C10.0385 18.1409 9.57332 18.6064 9 18.6064C8.42668 18.6064 7.96154 18.143 7.96154 17.5676V10.6445H1.03846C0.465144 10.6445 0 10.1798 0 9.60645C0 9.03486 0.465144 8.56755 1.03846 8.56755H7.96154V1.64447C7.96154 1.07116 8.42668 0.606445 9 0.606445C9.57332 0.606445 10.0385 1.07116 10.0385 1.64447V8.56755H16.9615C17.537 8.56755 18 9.03486 18 9.60601Z",
    fill: "#8A0538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.e8c80da2defee4a286f8d4b7e4ee5446.svg";
export { ForwardRef as ReactComponent };